<div
    class="flex items-center justify-center gap-4 px-24 py-4 text-grey-400 lg:justify-end"
    [ngClass]="{
        'text-white': theme() === 'dark' || theme() === 'medium',
    }"
>
    <i class="icon-info text-16"></i>
    <span class="text-[9px] md:text-12">
        @let l = label() | footnotes;
        <span [innerHTML]="l()"></span>
        &nbsp;
        <a class="underline" [hyundaiRouterLink]="dealer().pages.imprint">Impressum & Rechtliches</a>
    </span>
</div>
